import Vue from 'vue'
import Router from 'vue-router'
import { Message } from 'element-ui'
import { getLocal, delLocal, getCookie } from "@/utils/storage"
Vue.use(Router)
const router = new Router({
    mode: "history",
    scrollBehavior (to, from, saveTop) {
        if (saveTop) {
            return saveTop;
        } else {
            return { x: 0, y: 0 }
        }
    },
    routes: [
        {//首页
            path: '/',
            name: 'Index',
            component: () => import("@/pages/Index"),

        },{
            path: '/about',
            name: 'About',
            component: () => import("@/pages/About"),

        },{
            path: '/contact',
            name: 'Contact',
            component: () => import("@/pages/Contact"),

        },{
            path: '/privacy',
            name: 'Privacy',
            component: () => import("@/pages/Privacy"),

        },{
            path: '/clause',
            name: 'Clause',
            component: () => import("@/pages/Clause"),

        },
        // {//MOBA
        //     path: '/mobile',
        //     name: 'Mobile',
        //     component: () => import("@/pages/Mobile")
        // },
        // {//动作
        //     path: '/webpageGame',
        //     name: 'WebpageGame',
        //     component: () => import("@/pages/WebpageGame")
        // },
        // {//单机
        //     path: '/aloneGame',
        //     name: 'AloneGame',
        //     component: () => import("@/pages/AloneGame")
        // },
        // { //竞技
        //     path: '/develop',
        //     name: 'Develop',
        //     component: () => import("@/pages/Develop")
        // },
        /* { //招聘
            path: '/recruit',
            name: 'Recruit',
            component: () => import("@/pages/Recruit")
        }, */
        // { //冒险
        //     path: '/adventure',
        //     name: 'Adventure',
        //     component: () => import("@/pages/Adventure")
        // },
        // { //认证页
        //     path: '/authentication',
        //     name: 'Authentication',
        //     component: () => import("@/pages/Authentication")
        // },
        // {//内容页
        //     path: '/content/:id(\\d+)',
        //     name: 'Content',
        //     component: () => import("@/pages/Content")
        // },
        // {//详情页
        //     path: '/detail/:id(\\d+)',
        //     name: 'Detail',
        //     component: () => import("@/pages/Detail")
        // },
    ]
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
    //如果cookie中不存在token  清除本地缓存用户信息
    if (!getCookie("token")) {
        delLocal("userInfo")
    }
    let userInfo = getLocal("userInfo")
    if (to.path == "/authentication") {
        if (!userInfo) {
            next("/")
        } else if (userInfo.bCertification !== 0) {
            next("/")
        } else {
            next()
        }
    } else {
        next()
    }

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js